import { isEmpty, isDate } from 'lodash'

function pad(string) {
  return ('0' + string).slice(-2)
}

export default function (timestamp) {
  if (isEmpty(timestamp) && !isDate(timestamp)) {
    return timestamp
  }

  const date = new Date(timestamp)

  if (!date.valueOf()) {
    throw new Error('invalid date')
  }

  const yyyy = date.getFullYear()
  const mm = pad(date.getMonth() + 1)
  const dd = pad(date.getDate())
  const hh = pad(date.getHours())
  const m = pad(date.getMinutes())
  const s = pad(date.getSeconds())

  return `${yyyy}/${mm}/${dd} ${hh}:${m}:${s}`
}

export function inputDate(timestamp) {
  if (isEmpty(timestamp) && !isDate(timestamp)) {
    return timestamp
  }

  const date = new Date(timestamp)

  const yyyy = date.getFullYear()
  const mm = pad(date.getMonth() + 1)
  const dd = pad(date.getDate())

  return `${yyyy}-${mm}-${dd}`
}



// WEBPACK FOOTER //
// ./src/utils/time.js